import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { brandAlpha } from '../../theme/brandTokens';
import { useProUpgrade } from '../../context/ProUpgradeContext';
import ProCrownIcon from './ProCrownIcon';

const SIZE_PX = {
  tiny: 11,
  small: 14,
  medium: 18,
  large: 28,
};

const ProCrownButton = ({
  locked,
  size = 'small',
  stopPropagation = true,
  sx,
}) => {
  const { t } = useTranslation();
  const { isPro, openProUpgrade } = useProUpgrade();
  const show = locked ?? !isPro;

  if (!show) {
    return null;
  }

  const iconSize = SIZE_PX[size] || SIZE_PX.small;
  const label = t('storePlan.upgradeDialog.crownAria');

  const handleClick = (event) => {
    if (stopPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }
    openProUpgrade();
  };

  return (
    <Tooltip title={t('storePlan.upgradeDialog.crownTooltip')} arrow>
      <IconButton
        type="button"
        size="small"
        aria-label={label}
        onClick={handleClick}
        sx={{
          p: 0.25,
          '&:hover': {
            backgroundColor: brandAlpha('accent', 0.16),
          },
          ...sx,
        }}
      >
        <ProCrownIcon size={iconSize} />
      </IconButton>
    </Tooltip>
  );
};

export default ProCrownButton;
